import { styled, TextField, TextFieldProps } from '@mui/material';
import { useState } from 'react';
import { ReactComponent as ClearIcon } from '../../assets/icons/close-gray.svg';
import { useIcons } from '../../hooks/useIcons';

const Wrapper = styled('div')<{ isFocused: boolean }>`
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0 10px;
  border: 1px solid
    ${({ theme, isFocused }) =>
      isFocused ? theme.colors.border.accent : theme.colors.border.default};
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.border.accent};
  }
  .search-input {
    flex-grow: 1;
    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    .MuiInputBase-root .MuiInputBase-input {
      padding-left: 10px;
      padding-right: 0;
      color: ${({ theme }) => theme.colors.text.main};
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: transparent;
    }
    .Mui-disabled fieldset {
      border-color: transparent;
    }
    &:hover .Mui-disabled fieldset {
      border-color: 'transparent';
    }
  }
`;

export type ReadWriteFieldProps = TextFieldProps & {
  style?: React.CSSProperties;
  onClear?: () => void;
};

export function SearchInput(props: ReadWriteFieldProps) {
  const { style, onClear, ...rest } = props;
  const [isFocused, setIsFocused] = useState(false);
  const { SearchIcon } = useIcons();

  return (
    <Wrapper isFocused={isFocused} style={style}>
      <SearchIcon />
      <TextField
        className='search-input'
        {...rest}
        autoComplete='off'
        inputProps={{
          ...rest.inputProps,
        }}
        onBlur={() => setIsFocused(false)}
        onFocus={() => setIsFocused(true)}
      />
      {props.value && onClear ? (
        <ClearIcon style={{ cursor: 'pointer' }} onClick={onClear} />
      ) : null}
    </Wrapper>
  );
}
